import { render } from "./CandidatesList.vue?vue&type=template&id=1ec08b2f"
import script from "./CandidatesList.vue?vue&type=script&lang=js"
export * from "./CandidatesList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__